import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import '../../assets/css/comment.css'
import LawComment from '../modals/LawComment';


//images
import replayIcon from '../../assets/images/test/replay-icon.png';
import gotItIcon from '../../assets/images/test/got-it-icon.png';
import soundIcon from '../../assets/images/test/sound-icon.png';
import soundMutedIcon from '../../assets/images/test/mute-icon.png';
import commentMenu from '../../assets/images/test/dots.png';
import lawCommentIcon from '../../assets/images/test/law-comment-icon.png';
import playVideoIcon from '../../assets/images/search/icons/play-button-blue.png';
import commentIcon from '../../assets/images/test/comment-icon.png';

function Comment(props) {
    const [comment, setComment] = useState({
        commentOverlay: false,
        commentModal: false,
        paused: false,
        videosPrevArrow: false
    })

    const voice = document.getElementById('voice');
    const autoPlay = !comment.paused ? props.showComment ? true : false : false;

    const handleHideComment = e => {

        props.handleToggleComment(false);
        props.resize(true);

        // setComment(comment => {
        //     return {
        //         ...comment,
        //         paused: true
        //     }
        // });

        voice.pause();

    }

    // useEffect(() => {
    //     if (props.showComment) {
    //         setComment(comment => {
    //             return {
    //                 ...comment,
    //                 paused: false
    //             }
    //         });
    //     }

    // }, [props.showComment])

    const handleShowComment = (e) => {

        props.handleToggleComment(true);
        props.resize();

        if (!comment.paused) replayAudio();
    }

    const toggleAudio = () => {
        setComment(comment => {
            return {
                ...comment,
                paused: voice.paused ? false : true,
            }
        });

        if (voice.paused) {
            voice.play();
        } else {
            voice.pause();
        }
    }

    const replayAudio = () => {

        // setComment(comment => {
        //     return {
        //         ...comment,
        //         paused: false,
        //     }
        // });

        voice.currentTime = 0;
        voice.play();
    }

    const handleCommentModal = () => {
        setComment(comment => {
            return {
                ...comment,
                commentOverlay: true
            }
        })

        setTimeout(() => {
            setComment(comment => {
                return {
                    ...comment,
                    commentModal: true
                }
            })
        }, 50);
    }

    const handleCloseComment = () => {

        setComment(comment => {
            return {
                ...comment,
                commentModal: false
            }
        })
        setTimeout(() => {
            setComment(comment => {
                return {
                    ...comment,
                    commentOverlay: false
                }
            })
        }, 100)
    }

    const handleScroll = index => {
        const videosList = document.querySelectorAll('.videos-holder ul li')

        videosList[index].scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
        })

        setComment(prev => ({
            ...prev,
            videosPrevArrow: !prev.videosPrevArrow
        }))
    }

    return (
        <React.Fragment>
            {props.data.map(question =>
                question.id == String(props.currentQuestion) ?
                    question.comment && question.comment.law_comment && (props.checked.includes(String(question.id)) || props.isGiven) ?
                        <React.Fragment key={question.id}>
                            <div className={!props.showComment ? 'comment-wrapper hide' : 'comment-wrapper show'} data-id={question.id} key={question.id}>
                                <LawComment
                                    blur={comment.commentOverlay}
                                    popup={comment.commentModal}
                                    secondaryText={question.comment.law_comment}
                                    cancelCallback={handleCloseComment}
                                />
                                <h3>
                                    <img src={lawCommentIcon} />
                                    Коментар от закона (ЗДвП)
                                </h3>
                                <p>
                                    {question.comment.law_comment.length >= 120 ?
                                        <>
                                            {question.comment.law_comment.substring(0, 120)}...{' '}
                                            <span className="view-full-comment" onClick={handleCommentModal}>
                                                виж целия коментар
                                            </span>
                                        </>
                                        :
                                        question.comment.law_comment}
                                </p>
                                <div className="options">
                                    <Button onClick={toggleAudio} className="btn-sound">
                                        {comment.paused ?
                                            <img src={soundMutedIcon} alt="sound" />
                                            :
                                            <img src={soundIcon} alt="sound" />
                                        }
                                    </Button>
                                    <Button className="btn" onClick={replayAudio}>
                                        <img src={replayIcon} alt="replay" />
                                        Повтори
                                    </Button>
                                    <Button className="btn" data-id={question.id} onClick={handleHideComment}>
                                        <img src={gotItIcon} alt="got its" />
                                        Разбрах
                                    </Button>
                                    {window.innerWidth <= 1024 ?
                                        <Button className="btn" onClick={handleCommentModal}>

                                        </Button>
                                        :
                                        ''
                                    }
                                </div>
                                {question.videos[0] ?
                                    <div className="videos">
                                        <span className="learn-more">
                                            {/* Научи
                                            <br />
                                            повече */}
                                        </span>
                                        <div className={`videos-holder ${question.videos.length > 2 && window.innerWidth <= 1400 ? 'scrollable' : ''}`}>
                                            {comment.videosPrevArrow ?
                                                <span className="arrows left" onClick={() => handleScroll(0)}>

                                                </span>
                                                :
                                                ''}

                                            <ul>
                                                {question.videos.map(video =>
                                                    <li onClick={() => {
                                                        if (!voice.paused) {
                                                            voice.pause()
                                                        }

                                                        props.handleVideoComment(video.topic.video_id, video.start_pos, video.end_pos)
                                                    }}>
                                                        <picture style={{ backgroundImage: `linear-gradient(to right, #00000026, #00000026), url(${video?.poster})` }}>
                                                            <img src={playVideoIcon} />
                                                            <time>
                                                                {video.duration_formatted} мин
                                                            </time>
                                                        </picture>
                                                        <h4>
                                                            {video.name}
                                                        </h4>
                                                    </li>
                                                )}
                                            </ul>
                                            {!comment.videosPrevArrow ?
                                                <span className="arrows right" onClick={() => handleScroll(2)}>

                                                </span>
                                                :
                                                ''}
                                        </div>
                                    </div>
                                    :
                                    ''}
                            </div>
                            {window.innerWidth <= 1024 ?
                                !props.showComment && (props.checked.includes(String(props.currentQuestion)) || props.isGiven) ?
                                    <img src={commentMenu} id="mobileComment" className="mobile-comment" alt="comment" data-id={question.id} onClick={handleShowComment} />
                                    :
                                    ''
                                :
                                <Button data-id={question.id} onClick={handleShowComment} className={!props.showComment && (props.checked.includes(String(props.currentQuestion)) || props.isGiven) ? 'btn-comment btn-show' : 'btn-comment btn-hide'}>
                                    <img src={commentIcon} />
                                    Научи повече
                                </Button>
                            }
                            <audio id="voice" src={`${question.comment.voice_law}?token=${JSON.parse(localStorage.getItem('auth')).user.token}`} autoPlay={autoPlay} />
                        </ React.Fragment>
                        :
                        ''
                    :
                    ''
            )
            }

        </React.Fragment>

    )
}

export default Comment;